import ColorByStatus from './ColorByStatus'

function GridBoUserStatus({ able, isActive }) {

  const error = !isActive || !able 

  const ableStatus = able ? 'Activo' : 'Inactivo'
  const activeStatus = isActive ? ableStatus : 'Invitación enviada'


  return <ColorByStatus error={error} message={activeStatus} />
}

export default GridBoUserStatus